import { render, staticRenderFns } from "./editDictParamValue.vue?vue&type=template&id=2e97aeca&"
import script from "./editDictParamValue.vue?vue&type=script&lang=js&"
export * from "./editDictParamValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports